import { Header } from '../../../../../../../../commonComponents/CardList';
import { SearchOfficeName } from './SearchOfficeName';

export const OfficesHeader = () => (
  <Header title="Offices">
    <SearchOfficeName />
  </Header>
);
